import {Injectable} from "@angular/core";
import {SQLite, SQLiteObject} from "@ionic-native/sqlite";
import {Platform} from "ionic-angular";
import {TagItem} from "../models/tagItem";

@Injectable()
export class FindItemService {

  private DB_NAME = 'FindItem.db';
  private DB_LOCATION = 'default';
  private DB_TABLE_FOUND_ITEMS = 'FoundItems';
  private db: SQLiteObject;
  private DB_TABLE_COLUMN_UPC = 'upc';
  private DB_TABLE_COLUMN_ITEMS = 'items';

  constructor(public platform: Platform,
              private sqlite: SQLite) {
  }

  /**
   * Initializes the database (if not exists)
   */
  public init() {

    // Init database and table if table not exists
    //  Found Items Table columns:
    //    upc | items(TagItem[])

    this.sqlite.create({name: this.DB_NAME, location: this.DB_LOCATION}).then((db: SQLiteObject) => {
      this.db = db;
      this.db.executeSql('create table if not exists ' + this.DB_TABLE_FOUND_ITEMS + ' (' + this.DB_TABLE_COLUMN_UPC + ' VARCHAR(100), ' + this.DB_TABLE_COLUMN_ITEMS + ' VARCHAR(100))', {})
        .then(() => {
          console.log('Find Item database initialized');
          this.removeEmptyItemsFromDb();
        })
        .catch(e => console.log(e));
    }).catch(e => console.log(e));
  }

  public deleteDatabase(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.sqlite.deleteDatabase({name: this.DB_NAME, location: this.DB_LOCATION}).then(() => {
        console.log("Delete DB Find Item successful");
        resolve(true);
      }, err_ => {
        console.log("ERROR Delete DB Find Item");
        reject();
      });
    });
  }

  /**
   * Saves TagItem[] and corresponding UPC to database (as String)
   * @param upc The UPC to search
   * @param items The item list of type TagItem[]
   */
  public saveItems(upc: string, items: TagItem[]): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.db.executeSql('INSERT INTO ' + this.DB_TABLE_FOUND_ITEMS + ' VALUES(?,?)', [upc, JSON.stringify(items)])
        .then(res => {
          console.log('Inserted', upc);
          resolve(true);
        }).catch((error) => {
        console.log('Error inserting', error);
        reject();
      })
    });
  }

  /**
   * Resolves to a TagItem Array of length > 0 or rejects
   * @param upc: The UPC to get the saved items
   */
  public getItems(upc: string): Promise<TagItem[]> {
    return new Promise<TagItem[]>((resolve, reject) => {
      this.db.executeSql('select * from ' + this.DB_TABLE_FOUND_ITEMS + ' where ' + this.DB_TABLE_COLUMN_UPC + '=?', [upc])
        .then(res => {
          // Convert response from sql to items string
          let itemsList: TagItem[] = [];

          if(res.rows.item(0)){
            console.log('ROWS', res.rows);

            for (let i = 0; i < res.rows.length; i++) {
              console.log('Processing item list', res.rows.item(i).items);
              itemsList = JSON.parse(res.rows.item(i).items);
            }
          }

          console.log('Item list', itemsList);

          if (itemsList.length > 0) {
            resolve(itemsList);
          } else {
            reject('No saved items found in database');
          }

        }).catch(e => {
        console.log('Error getting Events from database', e);
        reject(e);
      });
    });
  }

  /**
   * Removes the items associated to the selected UPC
   * @param upc: The UPC to remove the items saved
   */
  public removeItemsFromDb(upc: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.db.executeSql('delete from ' + this.DB_TABLE_FOUND_ITEMS + ' where ' + this.DB_TABLE_COLUMN_UPC + '=?', [upc])
        .then(res => {
          console.log('Removed Items from db ', res);
          resolve(true);
        })
        .catch(e => {
          console.log('Error removing items from db', e);
          reject();
        });
    });
  }

  /**
   * Removes the items associated to the selected UPC
   * @param upc: The UPC to remove the items saved
   */
  private removeEmptyItemsFromDb(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.db.executeSql('delete from ' + this.DB_TABLE_FOUND_ITEMS + ' where ' + this.DB_TABLE_COLUMN_ITEMS + '=?', [JSON.stringify([])])
        .then(res => {
          console.log('Removed Empty Items from db ', res);
          resolve(true);
        })
        .catch(e => {
          console.log('Error removing empty items from db', e);
          reject();
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/find.item.service.ts